import axiosInstance from "utils/axiosInterceptor";

export function list(data: any) {
  return axiosInstance({
    url: "/company/list?" + data,
    method: "get",
  });
}

export function create(data: any) {
  return axiosInstance({
    url: "/company/create",
    method: "post",
    data: data,
  });
}

export function updateById(data: any) {
  return axiosInstance({
    url: "/company/updateById/" + data.id,
    method: "put",
    data: data,
  });
}

export function getById(id: string) {
  return axiosInstance({
    url: "/company/getById/" + id,
    method: "get",
  });
}

export function deleteById(id: string) {
  return axiosInstance({
    url: "/company/deleteById/" + id,
    method: "delete",
  });
}

export const apiMethod = { list, create, updateById, getById, deleteById };
